import script from "./Youtube-videos.vue?vue&type=script&setup=true&lang=js"
export * from "./Youtube-videos.vue?vue&type=script&setup=true&lang=js"

import "./Youtube-videos.vue?vue&type=style&index=0&id=52d1ec30&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52d1ec30"]])

export default __exports__